import type React from "react";
import { createContext, useContext } from "react";

export type Values = {
  sectionContainerTop?: number;
  sectionLineTop?: number;
  fixedSubItemTop?: number;
  transition?: boolean;
  shouldShowNavbar?: boolean;
};

type IScrollState = {
  values: Values;
  isScrolledAboveFold: boolean;
};

type IScrollActions = {
  setIsScrolledAboveFold: (v: boolean) => void;
  setValues: React.Dispatch<React.SetStateAction<Values>>;
};

export const DEFAULT_VALUES_OBJECT = {
  sectionContainerTop: 0,
  sectionLineTop: 0,
  fixedSubItemTop: 0,
  transition: false,
  shouldShowNavbar: true,
};

const DEFAULT_STATE: IScrollState = {
  isScrolledAboveFold: true,
  values: DEFAULT_VALUES_OBJECT,
};

export const ScrollContext = createContext<[IScrollState, IScrollActions]>([
  DEFAULT_STATE,
  {} as IScrollActions,
]);

export const useScrollContext = () => useContext(ScrollContext);
